module.exports = __webpack_public_path__ + "media/images/bannerVi-25e3768198fd9cc82b3ae58c72341545.png";